import React from 'react';
import { MapPin, Clock, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useNavigate } from 'react-router-dom';

const JobCard = ({ job }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleApply = () => {
    navigate(`/apply/${job.id}`, { state: { job } });
  };

  return (
    <div 
      className="bg-white rounded-xl shadow-xl border border-slate-100 p-6 flex flex-col gap-4 hover:border-blue-200 transition-colors relative overflow-hidden group"
      data-testid={`job-card-${job.id}`}
    >
      {/* Animated accent bar */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-indigo-500 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
      
      <div className="flex flex-col gap-2">
        <h3 className="text-xl font-bold text-slate-900" data-testid={`job-title-${job.id}`}>
          {job.title}
        </h3>
        
        <div className="flex flex-wrap gap-3 text-sm text-slate-600">
          <div className="flex items-center gap-1" data-testid={`job-location-${job.id}`}>
            <MapPin className="w-4 h-4" />
            <span>{job.location}</span>
          </div>
          <div className="flex items-center gap-1" data-testid={`job-type-${job.id}`}>
            <Clock className="w-4 h-4" />
            <span>{job.position_type}</span>
          </div>
        </div>
      </div>
      
      <p className="text-slate-600 leading-relaxed line-clamp-3" data-testid={`job-description-${job.id}`}>
        {job.description}
      </p>
      
      <button
        onClick={handleApply}
        className="mt-auto bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-lg shadow-lg hover:shadow-blue-500/30 transition-all flex items-center justify-center gap-2 group/btn"
        data-testid={`apply-button-${job.id}`}
      >
        <span>{t('applyNow')}</span>
        <ChevronRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
      </button>
    </div>
  );
};

export default JobCard;